var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cont"},_vm._l((Object.keys(_vm.localValue)),function(key){return _c('div',{key:key},[_c('h3',[_vm._v(_vm._s(key))]),_c('AppTextField',{attrs:{"outlined":""},model:{value:(_vm.localValue[key]),callback:function ($$v) {_vm.$set(_vm.localValue, key, $$v)},expression:"localValue[key]"}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }